import { Tooltip } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Tier } from "components/Admin/Organizations/types/Tier.type";
import { BranchDataProps } from "components/UI/AcxRecursiveTree/AcxRecursiveTreeBranch";
import React from "react";
import { OrganizationServiceHierarchyStore } from "../stores/OrganizationServiceHierarchyStore";
import theme from "Theme/AppTheme";

interface EditTierIconProps {
    tier: BranchDataProps;
    isLeaf?: boolean;
    osmStore: OrganizationServiceHierarchyStore;
}


const EditTierIcon: React.FC<React.PropsWithChildren<React.PropsWithChildren<EditTierIconProps>>> = ({ tier, osmStore }) => {
    return (
        <Tooltip title={"Tier Settings"}>
            <SettingsIcon
                htmlColor="#bebebe"
                cursor="pointer"
                onClick={() => {
                    osmStore.setActiveTier(tier as Tier);
                    osmStore.openEditTierDrawer();
                }}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                    cursor: "pointer",
                }}
            />
        </Tooltip>
    );
};

export default EditTierIcon;
